function getNextTwoDays() {
  const today = new Date();
  const dayOfWeek = today.getDay(); 
  const hour = today.getHours();
  const date = today.getDate();
  const month = today.getMonth() + 1; 

  let tomorrow = new Date(today);
  let dayAfterTomorrow = new Date(today);

  // General Friday logic
  if (dayOfWeek === 5) { // Friday
    if (hour < 14) {
      // Before 14:00: Saturday - Monday
      tomorrow.setDate(today.getDate() + 1); 
      dayAfterTomorrow.setDate(today.getDate() + 3); 
    } else {
      // After 14:00: Monday - Tuesday
      tomorrow.setDate(today.getDate() + 3); 
      dayAfterTomorrow.setDate(today.getDate() + 4); 
    }
  } else {
    // Adjust normally for other days
    tomorrow.setDate(tomorrow.getDate() + 1);
    dayAfterTomorrow.setDate(dayAfterTomorrow.getDate() + 2);
  }

  // Special holiday logic for December and January
  const specialDates = {
    '12-22': [23, 27], 
    '12-23': [27, 28], 
    '12-24': [27, 28], 
    '12-25': [27, 28],
    '12-26': [27, 28],
    '1-1': [2, 3], 
  };
  
  const key = `${month}-${date}`;
  if (specialDates[key]) {
    tomorrow = new Date(today.getFullYear(), month - 1, specialDates[key][0]);
    dayAfterTomorrow = new Date(today.getFullYear(), month - 1, specialDates[key][1]);
  }

  // Check and adjust for Sundays only
  if (tomorrow.getDay() === 0) {
    tomorrow.setDate(tomorrow.getDate() + 1);
    dayAfterTomorrow.setDate(dayAfterTomorrow.getDate() + 1);
  }
  if (dayAfterTomorrow.getDay() === 0) {
    dayAfterTomorrow.setDate(dayAfterTomorrow.getDate() + 1);
  }

  const options = { month: 'long' };
  const tomorrowFormatted = tomorrow.toLocaleDateString('en-US', options);
  const dayAfterTomorrowFormatted = dayAfterTomorrow.toLocaleDateString('en-US', options);

  return `${tomorrow.getDate()}-${dayAfterTomorrow.getDate()} ${tomorrowFormatted}`;
}

const dateOutput = getNextTwoDays();
const dateElement = document.querySelector('.cstm-date');

if (dateElement !== null) {
    dateElement.textContent = dateOutput;
} else {
    console.error('No element with the class "cstm-date" found.');
}


document.querySelectorAll('.short-prod-desc-cls').forEach(function(element) {
    element.addEventListener('click', function() {
        this.style.display = 'none';
        document.querySelectorAll('.full-prod-desc-cls').forEach(function(fullElement) {
            fullElement.style.display = 'block';
        });
    });
});
 

$(document).ready(function(){
  $('.product__slides.product-single__photos').each(function() {
      var numSlides = $(this).find('.product__slide').length;
      var dots = '';
      for (var i = 0; i < numSlides; i++) {
          dots += '<span class="dot"></span>';
      }
      $(this).parents('.product__images.product__images--thumbs').find('.cstm-dots-cls').html(dots); // Assuming dots container has a class "dots", change this selector accordingly if needed
  });

  $('.cstm-dots-cls .dot:eq(0)').addClass('active')
  
  $('.cstm-dots-cls .dot').click(function(){
    $('.cstm-dots-cls .dot').removeClass('active');
    $('.product__slide').removeClass('media--active').addClass('media--hidden'); // Move this line here
    var ind = $(this).index();
    $(this).addClass('active');
    $('.product__slide').each(function(){
        var indx = $(this).index(); 
        if(indx == ind){
            $(this).removeClass('media--hidden').addClass('media--active');
        }
    })
  })
  
  $('.product__wrapper__inner .slider__arrows .slider__button').click(function(){
    $('.product__wrapper__inner .cstm-dots-cls .dot').removeClass('active');
    var inde = $('.product__slide.media--active').index();
    $('.cstm-dots-cls .dot').each(function(){
        var index = $(this).index();
        if(inde == index ){
            $(this).addClass('active');
        }
    })
  })

  
})

